// Agency timezone helpers — all DAR / business-check times display in Eastern
// (EST/EDT auto-switching) no matter how the terminal's device clock is set.
export const AGENCY_TZ = "America/New_York";

export const fmtHHMM = (ts) => {
  if (!ts) return "—";
  let iso = ts;
  // Normalize naive ISO strings (no offset) as UTC so they can't re-shift.
  if (typeof iso === "string" && !/[Zz]|[+-]\d{2}:\d{2}$/.test(iso)) iso = iso + "Z";
  return new Date(iso).toLocaleTimeString("en-GB", {
    timeZone: AGENCY_TZ, hour: "2-digit", minute: "2-digit", hour12: false,
  }).replace(":", "");
};

export const agencyDate = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: AGENCY_TZ });

// Minutes WEST of UTC for the agency zone right now (240 EDT / 300 EST) —
// same convention as JS getTimezoneOffset, for the backend tz_offset param.
export const agencyOffsetMinutes = () => {
  const now = new Date();
  const ny = new Date(now.toLocaleString("en-US", { timeZone: AGENCY_TZ }));
  return Math.round((now.getTime() - ny.getTime()) / 60000);
};
